import { Alert, Box, Button, Stack, Typography } from '@mui/material';

const isChunkLoadError = (error) => error?.name === 'ChunkLoadError'
  || /Loading (?:CSS )?chunk .+ failed/i.test(error?.message || '');

function BookingDetailsUnavailable() {
  return <Box sx={{ m: { xs: 2, sm: 3 } }}>
    <Stack spacing={2}>
      <Typography variant="h5">Booking Details</Typography>
      <Alert severity="error">The booking details page could not be downloaded. Reload the page to get the latest version.</Alert>
      <Box><Button variant="contained" onClick={() => window.location.reload()}>Reload page</Button></Box>
    </Stack>
  </Box>;
}

// Webpack can request a chunk again after a failed download. Retry once;
// persistent failures need a fresh entry bundle rather than an endless retry loop.
export default async function loadBookingDetails(importPage = () => import('./SubPages/BookingOrderDetails')) {
  try {
    return await importPage();
  } catch (error) {
    if (!isChunkLoadError(error)) throw error;
  }
  try {
    return await importPage();
  } catch (error) {
    if (!isChunkLoadError(error)) throw error;
    return { default: BookingDetailsUnavailable };
  }
}
